<template>        
    <v-data-table
        v-if="filteredResources.length"
        :headers="doc_headers"
        :items="filteredResources"
        disable-pagination
        hide-default-footer>
        
        <template v-slot:header="{ headers }">
            <thead>
                <tr>
                    <td v-for="column in headers" :key="column.value">
                        {{column.text}}
                    </td>
                </tr>
            </thead>
        </template>

        <template v-slot:body="{ items }">
            <tbody name="list" is="transition-group">
                <tr v-for="item in items" :key="item.key" class="item-row avenir_book table_body">
                    <td>
                        <a v-if="!item.type.includes('video')" :href="item.url" class="clean_link" target="_blank">{{ item.file_name }}</a>
                        <a v-else @click="openVideo( { fileid: item.file_id, url: item.url, title: item.file_name, type: item.type, access: 'resource_docs' } )">{{ item.file_name }}</a>
                    </td>
                    <td v-html="item.description"></td>
                </tr>
            </tbody>
        </template>
    </v-data-table>
</template>

<script>  
    export default {
        name: 'ProjectResources',

        props: {
            projectResources: {},
            playResourceVideo: Function
        },

        data () {
            return {
                doc_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true,
                        width: '42%'
                    },
                    {   text: 'Description',     
                        value: 'description',
                        align: 'start',    
                        sortable: true
                    }
                ]
            }
        },

        computed: {
            filteredResources () {
                const filtered_resources = this.projectResources.resources.filter( rec => rec.is_visible )
                return filtered_resources
            }
        },

        methods: {
            openVideo ( data ) {
                this.$emit('playResourceVideo', data )
            }
        }
    }
</script>

<style scoped>
    .table_body td {
        padding-top: .5rem !important; 
        padding-bottom: .5rem !important;
        vertical-align: top !important;
    }
    .clean_link {
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectResources.vue